// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"d0aac37b","157":"471d34d5","423":"bb6e3768","453":"b70f62b0","595":"e86107df","750":"37b8b963","842":"c2757ec8","928":"a9090c80","988":"4fc82011"}[chunkId] + ".chunk.js";
};